(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AppController', AppController)
 
    AppController.$inject = ["PizarraService","GenerallabService","socket","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function AppController(PizarraService,GenerallabService,socket,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.avisos = [];
        vm.timers = {};
        vm.generalLab = GenerallabService;
	    console.log("appcont");
	    socket.on("pizarra:nuevacartaaviso",function(data){
            console.log("nuevacarta");
            //if(vm.esVisibleParaMi(data.carta)){
                vm.num_cartas++;
            	console.log("ES VISIBLE");
            	vm.avisos.push(data.carta);
            	var index = vm.avisos.length-1;
            	vm.timers[data.carta.id] = $timeout(function(){
            		vm.eliminarCarta(data.carta);
            	},60000)
            //}
        })

        vm.eliminarCarta = function(carta){
        	var res  = false;
        	for(var cont=0;cont<vm.avisos.length && !res;cont++){
        		if(vm.avisos[cont].id==carta.id){
            		vm.avisos.splice(cont,1);
            		if(vm.timers[carta.id]){
      					$timeout.cancel(vm.timers[carta.id]);
            		}
        		}
        	}
        }

        vm.init = function(username,categorias_ids){
        	vm.user_id = username;
            socket.emit('pizarra:join', {room:'pizarra',username:username,categorias_ids:categorias_ids});
        	PizarraService.getUsuarioCartas(function(data){
                vm.num_cartas = data.num_cartas;
        		vm.misCategorias = data.misCategorias;
        	})
	    }

        /*vm.esVisibleParaMi = function(carta){
            var res = false;
            var categorias_ids = [];
            for(var cont=0;cont<vm.misCategorias.length;cont++){
                categorias_ids.push(""+vm.misCategorias[cont].id);
            }

            console.log(categorias_ids,"cat_ids");
            console.log(carta.categoriapizarra_id,"cat");


            if(categorias_ids.indexOf(""+carta.categoriapizarra_id) !== -1 || carta.user_id==vm.user_id) {
                res = true;
            }
            return res;
        }*/
    }
  
})();